var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobileIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 12 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#mobile-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.26.582H3.28a2.487 2.487 0 0 0-2.49 2.49v9.961c0 1.375 1.11 2.49 2.49 2.49h4.98c1.37 0 2.49-1.115 2.49-2.49V3.072c0-1.375-1.12-2.49-2.49-2.49Zm-5.81 2.49c0-.458.37-.83.83-.83h4.98c.46 0 .83.372.83.83v9.961a.83.83 0 0 1-.83.83H3.28a.83.83 0 0 1-.83-.83V3.072Zm2.49 7.47a.83.83 0 1 0 0 1.661H6.6a.83.83 0 1 0 0-1.661H4.94Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "mobile-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5)",
  d: "M0 0h11v16H0z"
})))));
export { SvgMobileIcon as ReactComponent };
export default __webpack_public_path__ + "images/mobile-icon.svg";